import { createFileRoute } from '@tanstack/react-router';

import { TravelBoardRequestBrowse } from '@/module/Travel/Approval/TravelBoardRequestBrowse';

export const Route = createFileRoute('/_auth/travel/_travel/board-requests/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TravelBoardRequestBrowse />;
}
